import { Pager, ProductVariant, TrackingHistoryTimeline } from "@sgm-frontend/core";
export interface ReturnProductList extends Pager {
    records: ReturnProduct[];
}

export interface ReturnProduct {
    id: string;
    return_id: string;
    order_id: string;
    order_item_id: string;
    product_variant_id: string;
    cache_product_name: string | null;
    cache_items_total: number;
    item_price: number;
    quantity: number;
    reason: string;
    comment: string;
    refund_status: 'pending' | 'approved' | 'rejected'; // Adjust based on your enum values
    request_status: 'refund_approved' | 'refund_rejected' | 'request_rejected'; // Adjust based on your enum values
    rejected_reason: string | null;
    createdAt: string; // or Date if you plan to parse it
    tracking_return: TrackingHistoryTimeline[];
    return: ReturnDetails;
    product_variant: ProductVariant

}

export interface ReturnDetails {
    id: string;
    order_id: string;
    sub_total_refund: number;
    return_fee: number;
    grand_total_refund: number;
    payment_method: 'cash' | 'card' | string; // Adjust as per your allowed values
    createdAt: string; // or Date
}
export interface TrackingReturn {
    id: string;
    status: string;
    message: string;
    createdAt: string;
}